import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card border-0 bg-white profile-settings-card rounded-0" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_5 = {
  key: 0,
  class: "form-group mb-15 mb-sm-20 mb-md-25"
}
const _hoisted_6 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_7 = { class: "d-flex gap-3 align-items-center" }
const _hoisted_8 = ["value"]
const _hoisted_9 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, null, -1 /* HOISTED */)
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_13 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_14 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, null, -1 /* HOISTED */)
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_18 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_19 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_20 = { class: "col-12" }
const _hoisted_21 = { class: "form-check form-group form-switch mb-15 mb-sm-20 mb-md-25" }
const _hoisted_22 = {
  class: "form-check-label fw-medium position-relative top-1",
  for: "active"
}
const _hoisted_23 = { class: "col-md-6" }
const _hoisted_24 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_25 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_26 = {
  key: 0,
  class: "col-12 mt-25"
}
const _hoisted_27 = { class: "position-relative" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "position-absolute end-0 z-1 m-10" }, [
  /*#__PURE__*/_createElementVNode("div", {
    "data-bs-toggle": "modal",
    "data-bs-target": `#deleteCover`,
    class: "align-items-center bg-danger-subtle d-inline-flex fs-3 h-50 justify-content-center rounded-circle text-danger w-50 cursor-pointer"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "ph-bold ph-x" })
  ])
], -1 /* HOISTED */)
const _hoisted_29 = ["src"]
const _hoisted_30 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_31 = {
  key: 1,
  class: "col-12"
}
const _hoisted_32 = {
  key: 2,
  class: "col-md-12"
}
const _hoisted_33 = { class: "d-flex align-items-center justify-content-between gap-3 mb-25" }
const _hoisted_34 = {
  key: 0,
  type: "button",
  class: "bg-transparent p-0 border-0 text-danger lh-1 fw-medium",
  "data-bs-toggle": "modal",
  "data-bs-target": "#confirmModal"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", { class: "ph ph-trash lh-1 me-1 position-relative top-2" }, null, -1 /* HOISTED */)
const _hoisted_36 = { class: "position-relative" }
const _hoisted_37 = { key: 1 }
const _hoisted_38 = { class: "d-flex flex-wrap gap-3 justify-content-end ms-auto" }
const _hoisted_39 = {
  key: 3,
  class: "accordion border-0",
  id: "block-form-accordion"
}
const _hoisted_40 = { class: "accordion-item block-form border-0 rounded-0 border-0" }
const _hoisted_41 = ["data-bs-target", "aria-controls"]
const _hoisted_42 = { class: "d-sm-flex align-items-center justify-content-between pe-3" }
const _hoisted_43 = { class: "d-flex gap-3 align-items-center" }
const _hoisted_44 = { class: "block-handle fw-bold text-muted" }
const _hoisted_45 = { class: "fw-medium text-black-emphasis mb-0 flex-grow-1" }
const _hoisted_46 = { class: "text-muted text-uppercase small badge bg-light" }
const _hoisted_47 = ["id"]
const _hoisted_48 = { class: "border-0 mt-20 py-15 py-sm-20 py-sm-25 py-lg-30" }
const _hoisted_49 = {
  key: 4,
  class: "d-flex justify-content-between gap-3 mt-25 flex-wrap"
}
const _hoisted_50 = { class: "mb-8" }
const _hoisted_51 = { class: "row justify-content-center" }
const _hoisted_52 = { class: "col" }
const _hoisted_53 = {
  class: "alert alert-danger alert-dismissible fade border-0 border-danger-subtle border-top rounded-0 m-0 mb-25",
  role: "alert",
  id: "errorMessage"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_country_flag = _resolveComponent("country-flag")!
  const _component_SpinnerLoading = _resolveComponent("SpinnerLoading")!
  const _component_DiscardButton = _resolveComponent("DiscardButton")!
  const _component_ContentBlockForm = _resolveComponent("ContentBlockForm")!
  const _component_DraggableList = _resolveComponent("DraggableList")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!
  const _component_ContentBlockModal = _resolveComponent("ContentBlockModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", {
          onSubmit: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createCommentVNode(" LANG "),
            (_ctx.update)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_ctx.locales.length > 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('feature.contents.lang')), 1 /* TEXT */),
                        _createElementVNode("div", _hoisted_7, [
                          _createVNode(_component_country_flag, {
                            country: _ctx.lang,
                            size: "big"
                          }, null, 8 /* PROPS */, ["country"]),
                          _withDirectives(_createElementVNode("select", {
                            class: "form-select shadow-none text-black p-15 pe-50 fs-14 fw-medium w-auto",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.lang) = $event)),
                            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeLang())),
                            required: ""
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locales, (locale) => {
                              return (_openBlock(), _createElementBlock("option", {
                                value: locale,
                                key: locale
                              }, _toDisplayString(_ctx.$t(`feature.contents.$lang.${locale}`)), 9 /* TEXT, PROPS */, _hoisted_8))
                            }), 128 /* KEYED_FRAGMENT */))
                          ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                            [_vModelSelect, _ctx.lang]
                          ])
                        ]),
                        _createCommentVNode(" ERRORS "),
                        (_ctx.errors?.lang ?? false)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.lang, (error) => {
                                return (_openBlock(), _createElementBlock("p", {
                                  key: error,
                                  class: "small text-danger lh-1 m-0 mt-1"
                                }, _toDisplayString(error), 1 /* TEXT */))
                              }), 128 /* KEYED_FRAGMENT */))
                            ]))
                          : _createCommentVNode("v-if", true)
                      ]))
                    : _createCommentVNode("v-if", true)
                ]))
              : _createCommentVNode("v-if", true),
            _hoisted_10,
            _createCommentVNode(" NAME "),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('form.title.label')) + "* ", 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.content.title![_ctx.lang]) = $event)),
                  class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.title }]]),
                  required: ""
                }, null, 2 /* CLASS */), [
                  [_vModelText, _ctx.content.title![_ctx.lang]]
                ]),
                _createCommentVNode(" ERRORS "),
                (_ctx.errors?.title ?? false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.title, (error) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: error,
                          class: "small text-danger lh-1 m-0 mt-1"
                        }, _toDisplayString(error), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _hoisted_15,
            _createCommentVNode(" DESCRIPTION "),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('form.description.label')), 1 /* TEXT */),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.content.description![_ctx.lang]) = $event)),
                  class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.description }]]),
                  rows: "6"
                }, null, 2 /* CLASS */), [
                  [_vModelText, _ctx.content.description![_ctx.lang]]
                ]),
                _createCommentVNode(" ERRORS "),
                (_ctx.errors?.description ?? false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.description, (error) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: error,
                          class: "small text-danger lh-1 m-0 mt-1"
                        }, _toDisplayString(error), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _createCommentVNode(" ACTIVE "),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input shadow-none me-8",
                  type: "checkbox",
                  role: "switch",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.content.active) = $event)),
                  id: "active",
                  "true-value": 1,
                  "false-value": 0
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, _ctx.content.active]
                ]),
                _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t('form.active.label')), 1 /* TEXT */)
              ])
            ]),
            _createCommentVNode(" COVER CONTENT "),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t('feature.contents.$categories.imageCover')), 1 /* TEXT */),
                _createElementVNode("div", null, [
                  _createElementVNode("input", {
                    class: "form-control fs-15 text-black shadow-none",
                    type: "file",
                    id: "cover-picker",
                    onChange: _cache[5] || (_cache[5] = event => _ctx.fileUploaded(event)),
                    accept: "image/png, image/jpeg",
                    ref: "coverPickerRef"
                  }, null, 544 /* NEED_HYDRATION, NEED_PATCH */),
                  (_ctx.content.image_b64 && _ctx.content.image_b64 !== ' ')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _hoisted_28,
                          _createElementVNode("img", {
                            src: _ctx.content.image_b64,
                            alt: "image"
                          }, null, 8 /* PROPS */, _hoisted_29)
                        ])
                      ]))
                    : _createCommentVNode("v-if", true)
                ]),
                _createCommentVNode(" ERRORS "),
                (_ctx.errors?.image_b64 ?? false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.image_b64, (error) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: error,
                          class: "small text-danger lh-1 m-0 mt-1"
                        }, _toDisplayString(error), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  _createVNode(_component_SpinnerLoading, { class: "mb-25" })
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createCommentVNode(" DELETE "),
                    (_ctx.update)
                      ? (_openBlock(), _createElementBlock("button", _hoisted_34, [
                          _hoisted_35,
                          _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.$t('cta.delete_content')), 1 /* TEXT */)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_37)),
                    _createCommentVNode(" SAVE "),
                    _createElementVNode("div", _hoisted_38, [
                      _createVNode(_component_DiscardButton, {
                        onConfirm: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$router.push({ path: `/content-category/${_ctx.category_id}` })))
                      }),
                      _createElementVNode("button", {
                        class: "default-btn transition fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 fs-md-15 fs-lg-16",
                        type: "submit",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.submitted = true))
                      }, _toDisplayString(_ctx.$t('cta.save_content')), 1 /* TEXT */)
                    ])
                  ])
                ])),
            _createCommentVNode(" BLOCKS "),
            (_ctx.content.content_blocks)
              ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                  _createVNode(_component_DraggableList, {
                    list: _ctx.content.content_blocks,
                    "item-key": "id",
                    handle: ".block-form .block-handle",
                    sort: "true",
                    onStart: _ctx.dragStart,
                    onChange: _ctx.orderBlocks
                  }, {
                    item: _withCtx((block) => [
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("button", {
                          class: "accordion-button d-block w-100 text-start text-black fs-14 fs-md-15 fs-lg-16 fw-medium rounded-0 bg-white border-0 collapsed p-15 p-sm-20 p-sm-25 p-lg-30 pe-50",
                          type: "button",
                          "data-bs-toggle": "collapse",
                          "data-bs-target": `#block-tab-${block.element.id}`,
                          "aria-expanded": "false",
                          "aria-controls": `block-tab-${block.element.id}`
                        }, [
                          _createElementVNode("div", _hoisted_42, [
                            _createElementVNode("div", _hoisted_43, [
                              _createElementVNode("div", _hoisted_44, _toDisplayString(block.index + 1), 1 /* TEXT */),
                              _createElementVNode("h5", _hoisted_45, _toDisplayString(block.element.subtitle[_ctx.lang]), 1 /* TEXT */)
                            ]),
                            _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.$t(`feature.contents.$blocks.$type.${block.element.type}`)), 1 /* TEXT */)
                          ])
                        ], 8 /* PROPS */, _hoisted_41),
                        _createElementVNode("div", {
                          id: `block-tab-${block.element.id}`,
                          class: "accordion-collapse collapse border-0",
                          "data-bs-parent": "#block-form-accordion"
                        }, [
                          _createElementVNode("div", _hoisted_48, [
                            _createCommentVNode(" BODY "),
                            (_openBlock(), _createBlock(_component_ContentBlockForm, {
                              block: block.element,
                              key: block.element.id,
                              locale: _ctx.lang,
                              onUpdate: updated => _ctx.updateBlock(block.index, updated),
                              onChangeLang: _cache[8] || (_cache[8] = (event) => _ctx.changeLang(event)),
                              onDelete: ($event: any) => (_ctx.deleteBlock(block.index))
                            }, null, 8 /* PROPS */, ["block", "locale", "onUpdate", "onDelete"]))
                          ])
                        ], 8 /* PROPS */, _hoisted_47)
                      ])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["list", "onStart", "onChange"])
                ]))
              : _createCommentVNode("v-if", true),
            _createCommentVNode("  "),
            _createCommentVNode(" ADD "),
            (_ctx.update)
              ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                  _createElementVNode("p", _hoisted_50, _toDisplayString(_ctx.$t('feature.contents.$blocks.drag_reorder')), 1 /* TEXT */),
                  _createElementVNode("button", {
                    class: "ms-auto default-btn outlined transition fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 fs-md-15 fs-lg-16",
                    type: "button",
                    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.addBlock && _ctx.addBlock(...args)))
                  }, _toDisplayString(_ctx.$t('feature.contents.$blocks.add')), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true)
          ])
        ], 32 /* NEED_HYDRATION */)
      ])
    ]),
    _createCommentVNode(" ERROR MESSAGE "),
    _createElementVNode("div", _hoisted_51, [
      _createElementVNode("div", _hoisted_52, [
        _createElementVNode("div", _hoisted_53, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t('error.something_went_wrong')), 1 /* TEXT */),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.hideError && _ctx.hideError(...args))),
            "aria-label": "Close"
          })
        ])
      ])
    ]),
    _createVNode(_component_ConfirmModal, {
      onConfirm: _cache[12] || (_cache[12] = ($event: any) => (_ctx.deleteContent())),
      title: _ctx.$t('cta.$delete.title'),
      message: _ctx.$t('cta.$delete.message')
    }, null, 8 /* PROPS */, ["title", "message"]),
    (_ctx.update)
      ? (_openBlock(), _createBlock(_component_ContentBlockModal, {
          key: 0,
          id: "block_modal",
          content_id: _ctx.content.id!,
          order: _ctx.content.content_blocks?.length,
          onSave: _cache[13] || (_cache[13] = event => _ctx.saveBlock(event))
        }, null, 8 /* PROPS */, ["content_id", "order"]))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_ConfirmModal, {
      onConfirm: _cache[14] || (_cache[14] = ($event: any) => (_ctx.deleteCover())),
      id: `deleteCover`,
      title: _ctx.$t('cta.$delete.title'),
      message: _ctx.$t('cta.$delete.message')
    }, null, 8 /* PROPS */, ["title", "message"])
  ], 64 /* STABLE_FRAGMENT */))
}